module.exports = __webpack_public_path__ + "img/android.9fad9b5e.svg";